module.exports = __webpack_public_path__ + "img/BG.7ff2bbbd.png";